import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import About from "../components/About";
import Services from "../components/Services";
import Pillars from "../components/Pillars";
import Mission from "../components/Mission";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ChatBot from "../components/ChatBot";

export default function Home() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <Services />
        <Pillars />
        <Mission />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
}
